import EditIcon from '@/assets/icons/edit-icon.svg';
import UserIcon from '@/assets/icons/user-icon.svg';
import EmailIcon from '@/assets/icons/email-icon2.svg';
import FilterIcon from '@/assets/icons/filter-icon.svg';
import DotsIcon from '@/assets/icons/dots-icon.svg';
import SyncIcon from '@/assets/icons/sync-icon.svg';

export const ComponentNames = [
  'Project Details',
  'Ideal Candidates',
  'Candidate Pipeline',
  'Team Roster',
  'Autopilot Settings',
  'Outreach Methods',
  'Outreach Sequences',
  'Outreach Templates',
  'Job Titles',
  'Experience',
  'Professional Background',
  'Education',
  'Keywords',
  'Additional Considerations',
  'ATS Sync',
];

export const SelfServeComponentNames = [
  'Project Information',
  'Ideal Candidates',
  'Additional Information',
  'Team Roster',
  'Scheduling Preferences',
  'Outreach Sequences',
  'Outreach Templates',
  'Job Titles',
];

export const projectCreationFlow = [
  {
    name: 'Basic Information',
    children: [
      { name: 'Project Details', component: 'ProjectDetails' },
      { name: 'Ideal Candidates', component: 'IdealCandidates' },
      { name: 'Candidate Pipeline', component: 'CandidatePipeline' },
    ],
  },
  {
    name: 'Team Setup',
    children: [
      { name: 'Team Roster', component: 'TeamRosterSetup' },
      { name: 'Autopilot Settings', component: 'TeamAutopilotSettings' },
    ],
    // component: 'TeamSetup',
  },
  {
    name: 'Outreach Preferences',
    children: [
      { name: 'Outreach Methods', component: 'OutreachMethods' },
      { name: 'Outreach Sequences', component: 'FollowupSchedule' },
      { name: 'Outreach Templates', component: 'OutreachTemplates' },
    ],
  },
  {
    name: 'Search Preferences ',
    children: [
      { name: 'Job Titles', component: 'JobTitles' },
      { name: 'Experience', component: 'Experience' },
      { name: 'Professional Background', component: 'Companies' },
      { name: 'Education', component: 'Education' },
      { name: 'Keywords', component: 'SkillsKeywords' },
      // {
      //   name: 'Additional Considerations',
      //   component: 'AdditionalConsiderations',
      // },
    ],
  },
  {
    name: 'Additional Considerations',
    children: [],
    component: 'AdditionalConsiderations',
  },
  {
    name: 'ATS Sync',
    children: [],
    component: 'AtsSync',
  },
];
export const selfServeProjectCreationFlow = [
  {
    name: 'Basic Information',
    children: [
      { name: 'Project Details', component: 'ProjectDetails' },
      { name: 'Ideal Candidates', component: 'IdealCandidates' },
      {
        name: 'Additional Information',
        component: 'SelfServeAdditionalInformation',
      },
    ],
  },
  {
    name: 'Team Setup',
    children: [
      { name: 'Team Roster', component: 'SelfServeTeamRoster' },
      {
        name: 'Scheduling Preferences',
        component: 'SelfServeSchedulingPreferences',
      },
    ],
  },
  {
    name: 'Outreach Preferences',
    children: [
      { name: 'Outreach Sequences', component: 'FollowupSchedule' },
      { name: 'Outreach Templates', component: 'OutreachTemplates' },
    ],
  },
  {
    name: 'Search Preferences ',
    children: [
      { name: 'Job Titles', component: 'JobTitles' },
      { name: 'Education and Experience', component: 'EducationAndExperience' },
      { name: 'Professional Background', component: 'Companies' },
      { name: 'Keywords', component: 'SelfServeKeywords' },
    ],
  },
];

export const projectUpdateFlow = [
  {
    name: 'Basic Information',
    children: [
      { name: 'Project Details', component: 'ProjectDetails' },
      { name: 'Ideal Candidates', component: 'IdealCandidates' },
    ],
  },
  {
    name: 'Team Setup',
    children: [{ name: 'Team Roster', component: 'TeamRosterSetup' }],
  },
  {
    name: 'Outreach',
    children: [],
    component: 'OutreachTemplates',
  },
  {
    name: 'Search Preferences ',
    children: [],
    component: 'SearchPreferences',
  },
  {
    name: 'Additional Considerations',
    children: [],
    component: 'AdditionalConsiderations',
  },
  {
    name: 'ATS Sync',
    children: [],
    component: 'AtsSync',
  },
];
export const projectUpdateFlowAutopilot = [
  {
    name: 'Basic Information',
    children: [
      {
        name: 'Project Details',
        component: 'ProjectDetails',
        index: 0,
        isActive: true,
      },
      { name: 'Ideal Candidates', component: 'IdealCandidates', index: 1 },
      // { name: 'Candidate Pipeline', component: 'CandidatePipeline' },
    ],
    icon: EditIcon,
    index: 0,
    steps: [0, 1],
    isActive: true,
  },
  {
    name: 'Team Setup',
    children: [
      { name: 'Team Roster', component: 'TeamRosterSetup', index: 2 },
      {
        name: 'Autopilot Settings',
        component: 'TeamAutopilotSettings',
        index: 3,
      },
    ],
    icon: UserIcon,
    index: 2,
    steps: [2, 3],
    isActive: false,
  },
  {
    name: 'Outreach',
    children: [],
    component: 'OutreachTemplates',
    icon: EmailIcon,
    index: 4,
    steps: [4],
    isActive: false,
  },
  {
    name: 'Search Preferences ',
    children: [],
    component: 'SearchPreferences',
    icon: FilterIcon,
    index: 5,
    steps: [5],
    isActive: false,
  },
  {
    name: 'Additional Considerations',
    children: [],
    component: 'AdditionalConsiderations',
    icon: DotsIcon,
    index: 6,
    steps: [6],
    isActive: false,
  },
  {
    name: 'ATS connection settings',
    children: [],
    component: 'AtsSync',
    icon: SyncIcon,
    index: 7,
    steps: [7],
    isActive: false,
  },
];
export const projectUpdateFlowAutopilotV2 = [
  {
    name: 'Basic Information',
    children: [
      {
        name: 'Project Details',
        component: 'ProjectDetails',
        index: 0,
        isActive: true,
      },
      // { name: 'Candidate Pipeline', component: 'CandidatePipeline' },
    ],
    icon: EditIcon,
    index: 0,
    steps: [0],
    isActive: true,
  },
  {
    name: 'Team Setup',
    children: [
      { name: 'Team Roster', component: 'TeamRosterSetup', index: 1 },
      {
        name: 'Autopilot Settings',
        component: 'TeamAutopilotSettings',
        index: 2,
      },
    ],
    icon: UserIcon,
    index: 1,
    steps: [1, 2],
    isActive: false,
  },
  {
    name: 'Outreach',
    children: [],
    component: 'OutreachTemplates',
    icon: EmailIcon,
    index: 3,
    steps: [3],
    isActive: false,
  },
  {
    name: 'Scoring Preferences',
    children: [],
    component: 'ReviewSearchPrefs',
    icon: FilterIcon,
    index: 4,
    steps: [4],
    isActive: false,
  },
  {
    name: 'Additional Considerations',
    children: [],
    component: 'AdditionalConsiderations',
    icon: DotsIcon,
    index: 5,
    steps: [5],
    isActive: false,
  },
  {
    name: 'ATS connection settings',
    children: [],
    component: 'AtsSync',
    icon: SyncIcon,
    index: 6,
    steps: [6],
    isActive: false,
  },
];

export const projectUpdateFlowAutopilotHireflyAdminV2 = [
  {
    name: 'Basic Information',
    children: [
      {
        name: 'Project Details',
        component: 'ProjectDetails',
        index: 0,
        isActive: true,
      },
      // { name: 'Candidate Pipeline', component: 'CandidatePipeline' },
    ],
    icon: EditIcon,
    index: 0,
    steps: [0],
    isActive: true,
  },
  {
    name: 'Team Setup',
    children: [
      { name: 'Team Roster', component: 'TeamRosterSetup', index: 1 },
      {
        name: 'Autopilot Settings',
        component: 'TeamAutopilotSettings',
        index: 2,
      },
    ],
    icon: UserIcon,
    index: 1,
    steps: [1, 2],
    isActive: false,
  },
  {
    name: 'Outreach',
    children: [],
    component: 'OutreachTemplates',
    icon: EmailIcon,
    index: 3,
    steps: [3],
    isActive: false,
  },
  {
    name: 'Scoring Preferences',
    children: [],
    component: 'ReviewSearchPrefs',
    icon: FilterIcon,
    index: 4,
    steps: [4],
    isActive: false,
  },
  {
    name: 'Search Preferences ',
    children: [],
    component: 'SearchPreferences',
    icon: FilterIcon,
    index: 5,
    steps: [5],
    isActive: false,
  },
  {
    name: 'Additional Considerations',
    children: [],
    component: 'AdditionalConsiderations',
    icon: DotsIcon,
    index: 6,
    steps: [6],
    isActive: false,
  },
  {
    name: 'ATS connection settings',
    children: [],
    component: 'AtsSync',
    icon: SyncIcon,
    index: 7,
    steps: [7],
    isActive: false,
  },
];
export const projectUpdateFlowSelfServe = [
  {
    name: 'Basic Information',
    children: [
      { name: 'Project Details', component: 'ProjectDetails' },
      { name: 'Ideal Candidates', component: 'IdealCandidates' },
      {
        name: 'Additional Information',
        component: 'SelfServeAdditionalInformation',
      },
    ],
  },
  {
    name: 'Team Setup',
    children: [
      { name: 'Team Roster', component: 'SelfServeTeamRoster' },
      {
        name: 'Scheduling Preferences',
        component: 'SelfServeSchedulingPreferences',
      },
    ],
  },
  {
    name: 'Outreach Preferences',
    children: [
      { name: 'Outreach Sequences', component: 'FollowupSchedule' },
      { name: 'Outreach Templates', component: 'OutreachTemplates' },
    ],
  },
  {
    name: 'Search Preferences ',
    children: [
      { name: 'Job Titles', component: 'JobTitles' },
      { name: 'Education and Experience', component: 'EducationAndExperience' },
      { name: 'Professional Background', component: 'Companies' },
      { name: 'Keywords', component: 'SelfServeKeywords' },
    ],
  },
];

export const calendarSetupFlow = [
  {
    name: 'Calendar Setup',
    children: [],
    component: 'CalendarSetup',
  },
  {
    name: 'Interview Availablility',
    children: [],
    component: 'InterviewAvailablility',
  },
  {
    name: 'Meeting Preferences',
    children: [],
    component: 'MeetingSettings',
  },
];

export const defaultCandidate = [
  {
    approval_score: 2,
    approval_score_other: 'Professional background',
    approved_date: null,
    attended_top10_school: true,
    attended_top25_school: false,
    bounced_emails: null,
    certifications: null,
    comments: null,
    company_similarity_score: null,
    contacted_date: null,
    courses: null,
    current_company_size: null,
    current_job_title: 'Senior Software Engineer',
    desired_companies_yoe: 1.9232876712328768,
    domain_contacted: {
      contacted: false,
      contacted_by: null,
      contacted_date: null,
    },
    education: [
      {
        activities: null,
        degree: 'BS',
        grad_year: null,
        major: 'Computer Science and Business Administration (5%)',
        'py/object': 'models.Education',
        school: 'University of Southern California',
        schoolLogo:
          'https://media-exp1.licdn.com/dms/image/C4E0BAQHatTfEv4Af6w/company-logo_100_100/0/1519855864375?e=1666828800&v=beta&t=qqwiUYw_5vt6gwTe4aZNMAS6w3PYnHNnl_GXMPMJAR4',
      },
      {
        activities: null,
        degree: 'MS',
        grad_year: null,
        major: 'Computer Science',
        'py/object': 'models.Education',
        school: 'Georgia Institute of Technology',
        schoolLogo:
          'https://media-exp1.licdn.com/dms/image/C4E0BAQFuhLQoh5_7yA/company-logo_100_100/0/1640110531895?e=1666828800&v=beta&t=5S3GF-e5ulMzmYYco5idsOwybRohOknsAw0JMNiBuYw',
      },
    ],
    email_history: [],
    estimated_salary: null,
    eval_vec: [],
    experiences: [
      {
        company: 'DeepMind',
        companyLogo:
          'https://media-exp1.licdn.com/dms/image/C4E0BAQHmEuFTUfib5Q/company-logo_100_100/0/1657611982312?e=1666828800&v=beta&t=1GGMr970aBTQ4wquLowieI9MNnu6XeVrgZfDZmnGTf0',
        companyUrl: 'https://www.linkedin.com/company/1594050',
        days_on_job: 574,
        description:
          'Transformers for NLP & audiovisual understanding / generation: Perceiver, ViT, language models || research publication, UX study, Google(y) inventions || Conference & AI patents',
        end_date: 'Present',
        industry: ['Research'],
        location: 'London',
        'py/object': 'models.Job',
        start_date: 'Jan 2021',
        title: 'Research Engineer, Multimodal',
      },
    ],
    follow_up_1_date: null,
    follow_up_2_date: null,
    follow_up_3_date: null,
    gender: 'male',
    github: null,
    has_similar_company: true,
    headline: 'Something something data something ML',
    highest_ed_score: null,
    history: [
      {
        date: 'Sep 26, 2022',
        event: 1,
        is_scheduled: false,
        'py/object': 'models.HistoryEvent',
        user_id: 'ws1CkhAksH',
        user_name: 'Sameet Ramakrishnan',
        user_profile_picture:
          'https://lh3.googleusercontent.com/a/ALm5wu3FLsBKRPQd_MTHux5lva5YXZMBQryjRrY1WkRK=s96-c',
      },
    ],
    honors: null,
    ic_or_manager: null,
    id: '63322ccf3024e87227807f8c',
    industry: null,
    interview_date: null,
    invitation_profile_id: 'ACoAAAvI2RgBe-vYNJIr2Qefiv6n_Aql5q9jDUk',
    jt_embeddings: [],
    languages: null,
    likelihood_score: null,
    linkedin_profile_url: '',
    linkedin_recruiter_url: null,
    location: 'San Francisco,  California',
    manual_outreach: false,
    missing_keywords: [],
    name: 'Lorem Ipsum',
    not_interested_reason: null,
    not_interested_reason_other: null,
    note_to_hm: null,
    notes: null,
    opennewopportunities: null,
    organizations: null,
    other_bad_companies: [],
    other_bad_job_titles: [],
    outreach_templates: [],
    patents: null,
    personal_emails: null,
    picture_url: '',
    preferred_email: null,
    prof_emails: null,
    project_id: '',
    projects: null,
    publications: null,
    query: null,
    race: 'asian',
    reasons_to_hire: [{ Work: 'Work experience at similar company, Facebook' }],
    reasons_to_hire_likelihood: [{ Boost: 'Over a year in current role' }],
    reasons_to_hire_overall: [
      { Education: 'Great education from Yale University' },
    ],
    reasons_to_hire_similarity: [
      { Work: 'Appropriate level of seniority with 4 years of experience' },
    ],
    recommendations: [],
    rejection_reason: null,
    rejection_reason_other: null,
    relevant_yoe: 1.073972602739726,
    resume_key: null,
    school_prestige_score: null,
    score: 3,
    similarity_score: null,
    similary_score: -1000000,
    skills: [],
    skills_score: null,
    sq_id: null,
    status: 'WARM_LEADS_HM_APPROVED',
    sub_query: null,
    suggested_template: null,
    summary: null,
    summaryline: '',
    testScores: null,
    thread_email: 'aujerding@gmail.com, sameetr@hirefly.ai',
    thread_id: 'cpdzf31lav7bcawjotd8ewmtb',
    time_in_us: 10.093150684931508,
    visa_score: 5,
    volunteers: null,
    warm_leads_question_type: null,
    was_auto_swiped: false,
    why_bad_candidate: 'passed_for_bad_company',
    years_at_large_company: 2.178082191780822,
    years_at_medium_company: 1.0876712328767124,
    years_at_small_company: 0,
    years_of_exp: 5,
    yoe_score: null,
    _id: '',
  },
];

const sharedTour = [
  {
    xRight: '164px',
    y: '120px',
    triangle: 'right',
    title: 'Interested Candidate Email History',
    content: [
      'You will be able to see the initial outreach and any correspondence with the candidate in thread format. From this pane, you can correspond with the candidate and answer any questions asked.',
    ],
  },
  {
    xRight: '106px',
    yBottom: '15px',
    triangle: 'right',
    title: 'Edit Your Reply',
    content: [
      'Respond to candidate questions and address them from a Hirefly sender account.',
    ],
  },
  {
    xRight: '102px',
    yBottom: '-110px',
    triangle: 'right',
    lowerTriangle: true,
    title: 'Mail App: Short Reply Button',
    content: [
      'The short reply button can be used to answer most candidate questions, as set up by you during project onboarding.',
      'Visit Settings >> Basic Information >> Additional Information to make changes to your short reply messages.',
    ],
  },
];

export const selfServeAttentionTour = [
  {
    isDialog: true,
    title: 'Heads Up!',
    content: [
      'You have a candidate who has a question regarding your role. Please make sure you read the email and answer.',
      'But first, here is a short tutorial to explain the interface.',
    ],
    buttonOverride: "Let's Go!",
  },
  {
    x: '530px',
    y: '100px',
    triangle: 'top',
    title: 'Needs Attention',
    content: [
      'Needs Attention tab has candidates who have questions before they can express interest in your role.',
    ],
  },
  ...sharedTour,
  {
    xRight: '106px',
    yBottom: '100px',
    triangle: 'right',
    title: "Read Candidate's Reply",
    content: [
      'When the candidate has a question about the role, our AI defers to you to provide the best answer.',
      'We encourage you to read the email thread and answer candidate questions accordingly. Feel free to use the shortcut answers if relevant.',
      'If the AI has misclassified a candidate who is “interested” or “not interested” in the “needs attention” status, you can move the candidate to the correct status.',
    ],
  },
  {
    x: '616px',
    y: '486px',
    triangle: 'top',
    title: 'Move Users Between Statuses',
    content: [
      'Select the user by checking the right bottom box on the candidate card. You can select multiple candidates at once.',
      'Click "Choose Actions" and select the correct status you\'d like to move the candidate(s) to.',
    ],
  },
  {
    x: '212px',
    y: '174px',
    triangle: 'left',
    title: 'Duplicate, Pause, or Archive Project',
    content: [
      `Duplicate will make an exact copy of this project.`,
      'Pause will stop new outreach to candidates. You will still be able to review existing candidates in the pipeline. You can reactivate the project at any time.',
      'Archive will mark the project as inactive. You will still be able to view your project in the Archives folder. Your data will be saved and you can unarchive the project at any time from the dashboard.',
    ],
  },
];

export const selfServeReviewTour = [
  {
    isDialog: true,
    title: 'Congratulations!',
    content: [
      'You have interested candidates that you can review.',
      'Here is a short tutorial to explain the interface.',
    ],
    buttonOverride: "Let's Go!",
  },
  {
    x: '220px',
    y: '146px',
    triangle: 'top',
    title: 'Interested Candidates',
    content: [
      'Interested tab has candidates who are ready to interview.',
      'When you click the "Schedule Interview" button on the candidate card, Hirefly will send an instant intro email to you and the candidate and prompt the candidate to schedule time with you. The candidate card is then sent to the Scheduling tab.',
    ],
  },
  ...sharedTour,
  {
    xRight: '106px',
    yBottom: '100px',
    triangle: 'right',
    title: "Read Candidate's Reply",
    content: [
      'Our AI does a great job in making sure that the candidates we provide are indeed interested candidates.',
      "We encourage you to check the email thread to make sure the AI has not misclassified the candidate's response.",
      'You can move the candidate to a different section of the pipeline using the `Move` tool.',
    ],
  },
  {
    x: 'calc(calc(100% - 336px) * .497)',
    y: '462px',
    triangle: 'bottom',
    title: 'Move Tool',
    content: [
      'Click on "Move Tool" to move the candidates to a different pipeline tab or a different project.',
    ],
  },
  {
    x: 'calc(calc(100% - 336px) * .7)',
    y: '424px',
    triangle: 'bottom',
    title: 'Schedule Interview',
    content: [
      'Click on "Schedule Interview" to move forward with this candidate for a first interview. Upon clicking this button, Hirefly will send an instant intro email to you and the candidate and prompt the candidate to schedule time with you.',
    ],
  },
  {
    x: 'calc(calc(100% - 336px) * .27)',
    y: '424px',
    triangle: 'bottom',
    title: 'Reject Candidate',
    content: [
      'Click "Reject" to decline a candidate\'s interview request. Hirefly\'s AI will prompt you for a rejection reason to better adapt its search for the future. Hirefly will inform the candidate of your decision, but will not share your rejection reason or any notes you give.',
    ],
  },
  {
    x: '212px',
    y: '174px',
    triangle: 'left',
    title: 'Duplicate, Pause, or Archive Project',
    content: [
      `Duplicate will make an exact copy of this project.`,
      'Pause will stop new outreach to candidates. You will still be able to review existing candidates in the pipeline. You can reactivate the project at any time.',
      'Archive will mark the project as inactive. You will still be able to view your project in the Archives folder. Your data will be saved and you can unarchive the project at any time from the dashboard.',
    ],
  },
  {
    xRight: '-40px',
    y: '100px',
    triangle: 'top',
    shiftRight: true,
    title: 'Access this tutorial any time',
    content: [
      'Click on the question icon in your toolbar to revisit this tutorial at any time.',
    ],
  },
];
